<div class="question-fields" [formGroup]="questionForm()">
  <qai-field [label]="'simulationBuilder.KNOWLEDGE_CHECK_QUESTION_SCRIPT_LABEL' | transloco">
    <input qai-input type="text" qaiTrimLeading qaiPasteClean formControlName="script" />
  </qai-field>

  <div class="support-fields">
    <qai-field [label]="'simulationBuilder.KNOWLEDGE_CHECK_QUESTION_HINT_LABEL' | transloco">
      <span qaiSlot="tooltip" class="info-icon" #hintInfoIcon>
        <qai-icon kind="help-circle" size="16px" [color]="'var(--fg-tertiary)'" aria-hidden="true" />
      </span>
      <input qai-input type="text" qaiTrimLeading qaiPasteClean formControlName="hint" />
    </qai-field>
    <qai-field [label]="'simulationBuilder.KNOWLEDGE_CHECK_QUESTION_RESOURCE_LABEL' | transloco">
      <span qaiSlot="tooltip" class="info-icon" #resourceInfoIcon>
        <qai-icon kind="help-circle" size="16px" [color]="'var(--fg-tertiary)'" aria-hidden="true" />
      </span>
      <input qai-input type="text" qaiTrimLeading qaiPasteClean formControlName="resourceNote" />
    </qai-field>
  </div>

  <qai-tooltip [qaiFloating]="hintInfoIcon" [placement]="'above-center'" [events]="['hover']">
    {{ 'simulationBuilder.KNOWLEDGE_CHECK_QUESTION_HINT_TOOLTIP' | transloco }}
  </qai-tooltip>
  <qai-tooltip [qaiFloating]="resourceInfoIcon" [placement]="'above-center'" [events]="['hover']">
    {{ 'simulationBuilder.KNOWLEDGE_CHECK_QUESTION_RESOURCE_TOOLTIP' | transloco }}
  </qai-tooltip>
</div>
